/**
 * SummaryHeader - Header component for summary tables
 */

import React from "react";
import { TableHead, TableRow } from "@material-ui/core";
import { COLUMN_MODES } from "../../../constants";
import { StickyHeaderFirstCell, HeaderCell } from "../../styled";

/**
 * Summary table header component
 * @param {Object} props
 * @param {string} props.firstColumnLabel - Label for first column
 * @param {string} props.columnMode - Column display mode
 */
const SummaryHeader = ({ firstColumnLabel, columnMode }) => (
  <TableHead>
    <TableRow>
      <StickyHeaderFirstCell>{firstColumnLabel}</StickyHeaderFirstCell>
      <HeaderCell align="right">Hist. Permit (ac-ft)</HeaderCell>
      <HeaderCell align="right">Oper. Permit (ac-ft)</HeaderCell>
      <HeaderCell align="right">Total Permit (ac-ft)</HeaderCell>
      {columnMode === COLUMN_MODES.full && (
        <>
          <HeaderCell align="right">Jan</HeaderCell>
          <HeaderCell align="right">Feb</HeaderCell>
          <HeaderCell align="right">Mar</HeaderCell>
          <HeaderCell align="right">Apr</HeaderCell>
          <HeaderCell align="right">May</HeaderCell>
          <HeaderCell align="right">Jun</HeaderCell>
          <HeaderCell align="right">Jul</HeaderCell>
          <HeaderCell align="right">Aug</HeaderCell>
          <HeaderCell align="right">Sep</HeaderCell>
          <HeaderCell align="right">Oct</HeaderCell>
          <HeaderCell align="right">Nov</HeaderCell>
          <HeaderCell align="right">Dec</HeaderCell>
        </>
      )}
      <HeaderCell align="right">YTD (gal)</HeaderCell>
      <HeaderCell align="right">Rem. (gal)</HeaderCell>
      <HeaderCell align="right">YTD (ac-ft)</HeaderCell>
      <HeaderCell align="right">Rem. (ac-ft)</HeaderCell>
      <HeaderCell align="right" style={{ minWidth: 140 }}>
        % Permit
      </HeaderCell>
    </TableRow>
  </TableHead>
);

export default SummaryHeader;
